var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("ProgressCircular")
    : _c(
        "form",
        {
          attrs: { novalidate: "", disabled: _vm.disabled },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return (() => {}).apply(null, arguments)
            },
          },
        },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "8" } },
                [
                  _c(
                    "v-card",
                    {
                      attrs: {
                        "max-width": "1200px",
                        flat: "",
                        color: "transparent",
                      },
                    },
                    [
                      _c(
                        "v-card-title",
                        [
                          _c("FormHeader", {
                            attrs: {
                              loading: _vm.loading,
                              disabled: _vm.disabled,
                              link: "page-pages",
                              title: _vm.data.title
                                ? `${_vm.data.title}`
                                : `Создать страницу`,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-tabs",
                        {
                          model: {
                            value: _vm.activeTab,
                            callback: function ($$v) {
                              _vm.activeTab = $$v
                            },
                            expression: "activeTab",
                          },
                        },
                        _vm._l(_vm.$options.tabs, function (tab) {
                          return _c("v-tab", { key: tab.value }, [
                            _vm._v(" " + _vm._s(tab.title) + " "),
                          ])
                        }),
                        1
                      ),
                      _c(
                        "v-tabs-items",
                        {
                          model: {
                            value: _vm.activeTab,
                            callback: function ($$v) {
                              _vm.activeTab = $$v
                            },
                            expression: "activeTab",
                          },
                        },
                        [
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "PageContent",
                                    [
                                      _c(
                                        "v-container",
                                        [
                                          _c("InputTitleSlug", {
                                            attrs: {
                                              "is-loading":
                                                _vm.loading || _vm.disabled,
                                              title: _vm.fields.title,
                                              "title-error":
                                                _vm.validationErrors.title,
                                              slug: _vm.fields.slug,
                                              isSlugEnabled: !_vm.isNew,
                                              "slug-error":
                                                _vm.validationErrors.slug,
                                            },
                                            on: {
                                              "change:title": function (
                                                $event
                                              ) {
                                                _vm.fields.title = $event
                                              },
                                              "change:slug": function ($event) {
                                                _vm.fields.slug = $event
                                              },
                                              "input:slug":
                                                _vm.$v.fields.slug.$touch,
                                            },
                                          }),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "span",
                                                    [
                                                      _vm._v("Подзаголовок ("),
                                                      _c("TranslationIcon"),
                                                      _vm._v(")"),
                                                    ],
                                                    1
                                                  ),
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      outlined: "",
                                                      disabled: _vm.disabled,
                                                      loading: _vm.loading,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.fields.subtitle,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.fields,
                                                          "subtitle",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "fields.subtitle",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("MediaFilePicker", {
                                                    attrs: {
                                                      label: "Обложка",
                                                      multiple: false,
                                                      "file-type":
                                                        _vm.$options
                                                          .mediaTypesByKeys
                                                          .IMAGE,
                                                      value:
                                                        _vm.fields.coverImageId,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.fields.coverImageId =
                                                          $event
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                [
                                                  _c("MediaFilePicker", {
                                                    attrs: {
                                                      label: "Миниатюра",
                                                      multiple: false,
                                                      "file-type":
                                                        _vm.$options
                                                          .mediaTypesByKeys
                                                          .IMAGE,
                                                      value:
                                                        _vm.fields.thumbnailId,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.fields.thumbnailId =
                                                          $event
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "mr-5" },
                                                    [
                                                      _vm._v(
                                                        "Домашняя страница"
                                                      ),
                                                    ]
                                                  ),
                                                  _c("v-switch", {
                                                    attrs: {
                                                      inset: "",
                                                      dense: "",
                                                      disabled: _vm.disabled,
                                                      loading: _vm.loading,
                                                    },
                                                    model: {
                                                      value: _vm.fields.isHome,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.fields,
                                                          "isHome",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "fields.isHome",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("span", [
                                                    _vm._v("Место проведения"),
                                                  ]),
                                                  _c("LocationAutocomplete", {
                                                    attrs: {
                                                      address:
                                                        _vm.fields.address,
                                                      loading:
                                                        _vm.loading ||
                                                        _vm.disabled,
                                                    },
                                                    on: {
                                                      "set-location":
                                                        _vm.setLocation,
                                                      "update-location-part":
                                                        _vm.updateLocation,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("SeoSettings", {
                                                    attrs: {
                                                      data: _vm.data,
                                                      loading:
                                                        _vm.loading ||
                                                        _vm.disabled,
                                                    },
                                                    on: {
                                                      "on-input-seo": function (
                                                        $event
                                                      ) {
                                                        _vm.fields =
                                                          Object.assign(
                                                            {},
                                                            _vm.fields,
                                                            $event
                                                          )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "PageContent",
                                    [
                                      _c("DynamicListWrapper", {
                                        attrs: {
                                          list: _vm.fields.widgets,
                                          "error-messages":
                                            _vm.mixValidationErrors,
                                          "available-items":
                                            _vm.$options.availableWidgets,
                                          "copy-clipboard":
                                            _vm.mixCopyListItemClipboard,
                                          options: _vm.$options.options,
                                        },
                                        on: {
                                          "list-sort": _vm.mixListItemsReassort,
                                          add: _vm.mixCreateListItemHandler,
                                          option: _vm.mixListItemOptionHandler,
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "item",
                                            fn: function ({ data }) {
                                              return [
                                                _c(data.item.type, {
                                                  tag: "component",
                                                  attrs: {
                                                    "list-item": data.item,
                                                    "error-messages":
                                                      _vm
                                                        .mixDynamicListValidationErrors[
                                                        data.itemIndex
                                                      ],
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.mixListItemChangeHandler(
                                                        $event,
                                                        data.itemIndex
                                                      )
                                                    },
                                                    "change-item": function (
                                                      $event
                                                    ) {
                                                      return _vm.mixListItemChangeItemHandler(
                                                        $event,
                                                        data.itemIndex
                                                      )
                                                    },
                                                    "remove-item": function (
                                                      $event
                                                    ) {
                                                      return _vm.mixListItemRemoveItemHandler(
                                                        $event,
                                                        data.itemIndex
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c("ManageSidePanel", {
                    ref: "manageSidePanel",
                    attrs: {
                      isShowSortOrder: "",
                      "is-new": !_vm.data.id,
                      "created-at": _vm.data.createdAt,
                      "updated-at": _vm.data.updatedAt,
                      "published-at": _vm.data.publishedAt,
                      author: _vm.data.author,
                      "is-loading": _vm.loading,
                      "is-submit-disabled": _vm.disabled,
                      language: _vm.language,
                      translations: _vm.fields.translations,
                      "entity-id": _vm.data.id,
                      "entity-type": "page",
                      sortOrder: _vm.fields.sortOrder,
                    },
                    on: {
                      submit: _vm.submit,
                      delete: function ($event) {
                        return _vm.$emit("delete-page")
                      },
                      cancel: function ($event) {
                        return _vm.$router.push({ name: "page-pages" })
                      },
                      "update-translations": function ($event) {
                        return Object.assign(_vm.fields.translations, $event)
                      },
                      "language-update": function ($event) {
                        return _vm.$emit("language-update", $event)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "info-append",
                        fn: function () {
                          return [
                            _c("StatusPicker", {
                              attrs: {
                                align: "center",
                                cols: "12",
                                title: "Статус:",
                                disabled: _vm.disabled,
                                loading: _vm.loading,
                                status: _vm.fields.status,
                              },
                              on: {
                                "status:change": function ($event) {
                                  _vm.fields.status = $event
                                },
                              },
                            }),
                            !_vm.isNew
                              ? _c(
                                  "v-row",
                                  { attrs: { align: "center" } },
                                  [
                                    _c("v-col", { attrs: { cols: "6" } }, [
                                      _c("span", [
                                        _vm._v("Посмотреть на сайте"),
                                      ]),
                                    ]),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              icon: "",
                                              link: "",
                                              color: "primary",
                                              target: "_blank",
                                              href: _vm.redirerectToWebPortal,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                          },
                                          [_c("v-icon", [_vm._v("mdi-web")])],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }